<script setup lang="ts">
import { onMounted, ref } from "vue";

const root = ref();
let observer = null;

type EmitFunctions = {
  (e: "intersect"): () => void;
};
const emit = defineEmits<EmitFunctions>();

onMounted(() => {
  observer = new IntersectionObserver(([entry]) => {
    if (entry?.isIntersecting) {
      emit("intersect");
    }
  });
  observer.observe(root.value);
});
</script>

<template>
  <div class="observer" ref="root" />
</template>

<style scoped>
.observer {
  height: 1px;
}
</style>
